export default __webpack_public_path__ + "static/media/DNo.2-0.0b0d9693.jpg";